import React, { useState, useCallback } from 'react';
import { Button } from 'react-scale/components/design-system';
import SanitizedMarkdown from 'react-scale/components/design-system/SanitizedMarkdown';
import SfnProgressBar from 'react-scale/corp/components/SfnProgressBar/SfnProgressBar';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

const description = `
### Description: 
- This tool launches a job to refresh the customer audit data CSV and overview metric cards hosted on the insights dashboard
- Without manually running this tool, data will be refreshed every 2 hours
`;

const RefreshAudit: React.FC<{}> = () => {
  const [isExecuting, setIsExecuting] = useState<boolean>(false);
  const [executionArn, setExecutionArn] = useState<string>('');

  const handleRefresh = useCallback(async () => {
    setIsExecuting(true);
    try {
      const { success, executionArn } = await apiFetch(
        null,
        'corp-api/roadrunner-utils/refresh-audit',
        {
          method: 'POST',
          body: {},
        },
      );
      if (success) {
        setExecutionArn(executionArn);
      }
    } catch (error) {
      defaultApiFetchErrorHandler(error);
    }
    setIsExecuting(false);
  }, []);

  return (
    <div>
      <SanitizedMarkdown text={description} />
      <Button
        type="primary"
        disabled={isExecuting}
        onClick={handleRefresh}
        style={{ marginBottom: 20 }}
      >
        Start Refresh
      </Button>
      {executionArn.length ? <SfnProgressBar arn={executionArn} /> : <> </>}
    </div>
  );
};

export default RefreshAudit;
